import {Injectable} from '@angular/core';
import {NavigationItem} from '../../interfaces/navigation-items';
import {Router} from '@angular/router';
import {SideNavigationService} from './side-navigation.service';
import {PlatformService} from '../platform-service/platform.service';
import {UrlService} from '../url-service/url.service';
import {ScrollService} from '../scroll-service/scroll.service';
import {NavigationItemsService} from "../navigation-items-service/navigation-items.service";

@Injectable({
  providedIn: 'root',
})
export class NavigationItemClickService {

  private hasHandledDirectRouterLink = false;

  constructor(
    private readonly router: Router,
    private readonly sideNavigationService: SideNavigationService,
    private readonly platformService: PlatformService,
    private readonly urlService: UrlService,
    private readonly scrollService: ScrollService,
    private readonly navigationItemService: NavigationItemsService
  ) {

    if (!this.hasHandledDirectRouterLink) {
      this.hasHandledDirectRouterLink = true;
      const path = window.location.pathname;
      this.checkPathForProfilePageLinks(path);
    }
  }

  clickNavigationItem(_navigationItem: NavigationItem): void {

    if (_navigationItem.children?.length) {
      this.openNavOrToggleChildren(_navigationItem);
      return;
    }

    if (_navigationItem.click) {
      _navigationItem.click();
      return;
    }

    if (_navigationItem.href) {
      if (this.platformService.isMobile()) {
        this.sideNavigationService.closeSideNav();
      }
      setTimeout(() => {
        this.urlService.openURL(_navigationItem.href);
      });
      return;
    }

    if (_navigationItem.routerLink) {
      this.scrollService.forgetPosition(_navigationItem.routerLink);
      this.router.navigate([_navigationItem.routerLink]).then(() => {
      });
    }
  }

  openNavOrToggleChildren(_navigationItem: NavigationItem): void {
    if (this.sideNavigationService.isSideNavOpen()) {
      this.toggleChildren(_navigationItem);
    } else {
      this.sideNavigationService.openSideNav();
      _navigationItem.isOpenGroup = true;
    }
  }

  toggleChildren(_navigationItem: NavigationItem): void {
    _navigationItem.isOpenGroup = !_navigationItem.isOpenGroup;
  }

  checkPathForProfilePageLinks(currentUrl: string): void {
    const profilePage = this.navigationItemService.getProfilePage();

    const validChildRoutes = (profilePage.children || [])
      .map(child => child.routerLink)
      .filter((link): link is string => !!link && link !== '/');

    const matchesChildRoute = validChildRoutes.some(route => currentUrl.includes(route));

    if (matchesChildRoute) {
      this.toggleChildren(profilePage);
    }
  }
}
